// Single source of truth for the VCare office address shown on the public site.
export const OFFICE_ADDRESS_LINES = ['293/17B Thalapathpitiya Road,', 'Nugegoda, Sri Lanka.'];

// Google Maps pin for the office (opens the Maps app on phones).
export const OFFICE_MAP_URL = 'https://maps.app.goo.gl/tNophEaPiiU9jKGdA?g_st=ic';

// Keyless embeddable view of the same place, for the landing page map. It is pinned to the
// office's Google listing by cid (a text search shows the surrounding care providers instead).
export const OFFICE_MAP_EMBED_URL = 'https://maps.google.com/maps?cid=17218355818129540108&z=17&output=embed';

export const OFFICE_EMAIL = 'info@vcarenursing.com';
